import React from "react";
import cn from "classnames";
import parse, { domToReact } from "html-react-parser";

const Cards = ({ cards }) => {
  if (cards.length === 0) {
    return "No results found";
  }
  let filteredCards = cards;

  filteredCards = cards.map((card) => {
    const attribs = {};
    // if (card.isVideo) {
    //   attribs["data-module"] = "Popup";
    //   attribs["data-provider"] = card.acf.video_provider;
    //   attribs["data-video"] = card.acf.video_id;
    // }

    if (card.linkUrl) {
      attribs.href = card.linkUrl;
      attribs.target = card.linkTarget;
    }

    if (card.isPopup) {
      attribs["data-module"] = "Popup";
    }
    function getText(htmlString, className) {
      const Component = parse(htmlString, {
        replace: (domNode) => {
          if (domNode.name) {
            return (
              <div className={className}>{domToReact(domNode.children)}</div>
            );
          }
          return domNode;
        },
      });

      return Component;
    }

    return (
      <card.htmlTag
        key={card.id}
        className={cn("card", "shadow", card.postType)}
        {...attribs}
      >
        {card.cardImage && (
          <div className="card__image">
            <img src={card.cardImage} alt={card.featuredImage?.node?.altText} />

            {(card.acf?.modal_icon || card.acf?.modal_tier) && (
              <div className="service-partner-level">
                <p className="section-title">Lacework Service Partner Level</p>
                <p>
                  {card.acf?.modal_icon && (
                    <i>
                      <img src="//FIXME" alt={card.acf?.modal_tier} />
                    </i>
                  )}

                  {card.acf?.modal_tier && card.acf?.modal_tier}
                </p>
              </div>
            )}

            {card.acf?.certifications && (
              <div className="service-partner-certs">
                <p className="section-title">Certifications</p>
                {card.acf?.certifications &&
                  getText(card.acf?.certifications, "certs")}
              </div>
            )}

            {card.acf?.modal_offerings && (
              <div className="service-partner-offerings">
                <p className="section-title">Other offerings</p>
                {card.acf?.modal_offerings &&
                  getText(card.acf?.modal_offerings, "offerings")}
              </div>
            )}
          </div>
        )}
        <div className="card__body">
          {card.acf?.eyebrow && (
            <span
              className="eyebrow"
              dangerouslySetInnerHTML={{ __html: card.acf?.eyebrow }}
            ></span>
          )}
          {card.date && <span className="date">{card.date}</span>}
          {card.title && (
            <h4 dangerouslySetInnerHTML={{ __html: card.title }}></h4>
          )}
          {card.acf?.modal_description && (
            <p
              dangerouslySetInnerHTML={{
                __html: card.acf?.modal_description,
              }}
            />
          )}

          {card.postType !== "awards" && (
            <span
              className={cn(
                "button",
                `button--${card.isPopup && !card.isVideo ? "modal" : "link"}`
              )}
            >
              {card.acf?.cta_text || "See Details"}
            </span>
          )}

          {card.acf?.modal_url && (
            <a
              href={card.acf?.modal_url}
              className="button button--primary button--popup"
            >
              {card.acf?.modal_button}
            </a>
          )}
        </div>
      </card.htmlTag>
    );
  });

  return filteredCards;
};

export default Cards;
